import { enteteOrg, ENCRE, piedOrg, type MarqueDeDocument } from './branding-rendu.js';
import { echapper } from './echapper.js';

/**
 * LE DOCUMENT COMPLET, pret pour `genererPdf` : une page HTML autonome, en-tete
 * et pied a la marque de l'org, feuille d'impression.
 *
 * La TAILLE DE PAGE et les MARGES ne sont pas ici : ce sont les options de la
 * callable (`docs/PDF.md`), pour qu'un document ne dise pas A4 quand on
 * l'imprime en Letter. Ici, ce qui ne depend pas du papier : polices systeme
 * (le conteneur n'a pas le droit d'en telecharger), sauts de page, en-tetes de
 * tableau repetes, lignes et blocs jamais coupes en deux.
 */

export interface DocumentPdf {
  marque: MarqueDeDocument;
  /** Le titre, en tete du document et dans les proprietes du PDF. */
  titre: string;
  sousTitre?: string;
  /** Le corps : du HTML fait de blocs (`bloc`, `tableau`, `paragraphe`...), jamais de texte brut. */
  corps: string;
  /** La phrase du pied ; par defaut celle de `piedOrg`. */
  mention?: string;
}

const FEUILLE = [
  'html{-webkit-print-color-adjust:exact;print-color-adjust:exact}',
  `body{margin:0;font-family:system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Liberation Sans",sans-serif;font-size:11px;line-height:1.45;color:${ENCRE.texte}}`,
  'thead{display:table-header-group}tfoot{display:table-footer-group}',
  'tr,img,.bloc{break-inside:avoid}h2{break-after:avoid}',
  '.saut-de-page{break-before:page}',
].join('\n');

export function documentHtml(document: DocumentPdf): string {
  return (
    '<!doctype html><html lang="fr"><head><meta charset="utf-8">' +
    `<title>${echapper(document.titre)}</title><style>${FEUILLE}</style></head><body>` +
    enteteOrg(document.marque, { titre: document.titre, ...(document.sousTitre ? { sousTitre: document.sousTitre } : {}) }) +
    document.corps +
    piedOrg(document.marque, document.mention ? { mention: document.mention } : {}) +
    '</body></html>'
  );
}
